import { render, staticRenderFns } from "./CarriersDetails.vue?vue&type=template&id=0e5fe736&scoped=true"
import script from "./CarriersDetails.vue?vue&type=script&lang=js"
export * from "./CarriersDetails.vue?vue&type=script&lang=js"
import style0 from "./CarriersDetails.vue?vue&type=style&index=0&id=0e5fe736&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5fe736",
  null
  
)

export default component.exports